import { Injectable, OnDestroy } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, QueryFn } from '@angular/fire/firestore';
import { Store } from '@ngrx/store';
import { selectOrderCollectionName } from 'app/auth/auth.reducer';
import { Order, OrderParcel } from 'app/shared/shared.interfaces';
import { Observable, Subject, combineLatest, of } from 'rxjs';
import { switchMap, takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class OrderHelperService implements OnDestroy{

  collectionName: string = '';
  unsubscribe$ = new Subject<void>();

  constructor(private firestore: AngularFirestore, private store: Store) {
    this.store.select<string>(selectOrderCollectionName)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(orderCollectionName => {
        this.collectionName = orderCollectionName ?? 'orders'
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  getOrderObjectWithOrderId(orderId: string, queryFn: QueryFn = (value) => value): Observable<Order> {

    const ref = this.firestore.collection<Order>(this.collectionName, queryFn);
    return combineLatest(
      [
        this.getOrdersWithId(ref, orderId),
        this.getOrdersParcels(ref, orderId)
      ]).pipe(
      switchMap(([orders, parcels]) => {
        if(parcels?.length > 0){
          orders.Parcels = parcels
        }
        return of(orders);
      }));
  }

  private getOrdersWithId(ref: AngularFirestoreCollection<Order>, orderId: string): Observable<Order> {
    return ref
      .doc<Order>(orderId)
      .valueChanges();
  }

  private getOrdersParcels(ref: AngularFirestoreCollection<Order>, orderId: string): Observable<OrderParcel[]>{
    return ref
      .doc(orderId)
      .collection<OrderParcel>('parcels')
      .valueChanges();
  }

  getOrderObject(queryFn: QueryFn = (value) => value): Observable<Order[]> {
    const ref = this.firestore.collection<Order>(this.collectionName, queryFn);
    return ref.valueChanges();
  }
}
